import { MANAGE_OUTS_RESET_DATA } from './constants';

export function resetManageOutsData() {
  return {
    type: MANAGE_OUTS_RESET_DATA,
  };
}


